import { z } from 'zod';
/** Trims, normalizes blank strings to null, and accepts explicit null (optional API fields). */
export const optionalTrimmedNullableString = (maxLength, message) => z
    .string()
    .trim()
    .max(maxLength, message)
    .transform((value) => (value === '' ? null : value))
    .optional()
    .nullable();
//# sourceMappingURL=optional-trimmed-nullable-string.js.map